export default __webpack_public_path__ + "static/media/room-polen-3.3f932e41.jpg";